import comp from "./AIPanelHeader";
export default comp;
